import moment from 'moment'

/**
 *
 * @param {String, Date} date
 * @returns {Date} - Date in 'dd/mm/yyyy' format
 */
export function dateFormatter(date, format) {
  return moment(date, format).format('DD/MM/YYYY')
}

/**
 *
 * @param {String, Date} date
 * @returns {Date} - Date in 'dd/mm/yyyy hh:mm:ss' format
 */
export function dateTimeFormatter(date) {
  return moment(date).format('DD/MM/YYYY hh:mm:ss')
}

export function currencyFormatter(value) {
  if (value !== null && value !== undefined) {
    return Number(value).toLocaleString('en')
  }
  return null
}
